/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 749);
/******/ })
/************************************************************************/
/******/ ({

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(document).ready(function () {

    $(".faq-item .question span").click(function (e) {
        e.preventDefault();
        $(this).parent().parent().toggleClass("open");
    });

    if (document.querySelector('.header-main h1.title')) {
        document.querySelector('.header-main h1.title').classList.add("animated");
    }
    if (document.querySelector('.header-main .subtitle')) {
        document.querySelector('.header-main .subtitle').classList.add("animated");
    }
    if (document.querySelector('.header-main .btn')) {
        document.querySelector('.header-main .btn').classList.add("animated");
    }
    if (document.querySelector('header .header-image')) {
        document.querySelector('header .header-image').classList.add("animated");
    }

    function blocksVisibility() {

        function Check() {}

        Check.prototype = {
            constructor: Check,
            isElementInView: function isElementInView(element, fullyInView) {
                if (!element) return false;
                var pageTop = $(window).scrollTop();
                var pageBottom = pageTop + $(window).height();
                var elementTop = $(element).offset() && $(element).offset().top;
                var elementBottom = elementTop + $(element).height();

                if (fullyInView === true) {
                    return pageTop < elementTop && pageBottom > elementBottom;
                } else {
                    return elementTop <= pageBottom && elementBottom >= pageTop;
                }
            }
        };

        var Check = new Check();

        function doAnimate(elem) {

            var isElementInView = Check.isElementInView(elem, false);
            if (isElementInView) {
                if (!elem.hasClass('animated')) {
                    elem.addClass('animated');
                }
            }
        }

        var animateBloks = [$('.characteristics'), $('.app'), $('.faq'), $('.terms'), $('main > .button-wrapper').eq(0), $('.vue-form'), $('.filling'), $(".tariffs"), $('main > .button-wrapper').eq(1)];
        animateBloks.forEach(function (block) {
            doAnimate(block);
        });
    }
    window.addEventListener('scroll', blocksVisibility, { passive: true });
    blocksVisibility();

    $('.scrollToForm').on("click", function () {
        var el = document.querySelector('.vue-form');
        $('html, body').animate({ scrollTop: $(el).position().top }, 1000);
    });
});

/***/ })

/******/ });


// WEBPACK FOOTER //
// cashCredit.js